import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Tooltip } from 'antd';
import styles from './PanelHeader.module.scss';

const renderText = (title, content) => (
  <p className={styles.paragraph}>
    <span className={styles.accent}>{title}:</span> {content}
  </p>
);

const PanelHeader = ({ index, shutdown }) => {
  const { type, alertReason } = shutdown;

  return (
    <div className={styles.root}>
      <h4 className={styles.title}>Отключение {`${index}`}</h4>
      <div className={styles.metaData}>
        {Boolean(type) && renderText('Тип', type.name)}
        {Boolean(alertReason) && renderText('Причина', alertReason.name)}
      </div>
      <Tooltip title="Перейти к отключению">
        <Link
          onClick={(e) => e.stopPropagation()}
          className={styles.link}
          target="_blank"
          to={{
            pathname: '/Shutdowns',
            search: `?search=${shutdown?.alertId || shutdown?.id}`,
          }}
        >
          <Icon type="link" />
        </Link>
      </Tooltip>
    </div>
  );
};

export default PanelHeader;
